<template>
  <div>
    <PageHeader :schema="$schemas.cashFlow" />
    <PageContent>
      <DynamicFormPage :schema="$schemas.cashFlow" :service="$api.cashFlows" />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateCashFlow',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
